const osdFeatures = {
  namespaced: true,
  state: {
    osdFeatureList: [],
    jwtToken: null,
  },
  mutations: {
    updateOsdFeatureList(state, newList) {
      if (Array.isArray(newList)) {
        state.osdFeatureList = newList
      } else {
        console.error('Error: updatesomeList received non-array data', newList)
        state.osdFeatureList = []
      }
    },
    updateJwtToken(state, token) {
      state.jwtToken = token
    },
  },
  actions: {
    async getOsdFeatureList(context) {
      try {
        const response = await this._vm.$traveller_http.get(
          `/traveller/restui/organizations/features/osd`
        )
      
        const features = response.data.features
        if (!Array.isArray(features)) {
          console.error('Error: API did not return an array', features)
          return
        }
        if (response.data.jwtToken) {
          await context.commit('updateJwtToken', response.data.jwtToken)
        }
        await context.commit('updateOsdFeatureList', features)
      
        
      } catch (error) {
        console.error('API Error:', error)
      }
    },
  },
  getters: {
    getByName: (state) => (name) => {
      return state.osdFeatureList.find((item) => item.name === name) || ''
    },
  },
}

export default osdFeatures
